import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
const animateCases = () => {
  let progressCases = 0

  const timelineCases = gsap.timeline({
    scrollTrigger: {
      trigger: '#cases',
      pin: true,
      scrub: 1,
      start: 'top top',
      endTrigger: '.cases__wrap',
    },
  })

  const scrollCases = (e) => {
    setTimeout(() => {
      if (e !== undefined && (e.type === 'resize' || e.type === 'orientationchange')) {
        progressCases = timelineCases.progress()
        timelineCases.clear()
        ScrollTrigger.refresh()
      }

      timelineCases.fromTo(
        '.cases__wrap',
        {
          y: 0,
          force3D: false,
        },
        {
          ease: 'linear',
          y: `-${$('.cases__wrap').outerHeight() - $(window).height()}px`,
          force3D: false,
        },
        0
      )
      timelineCases.progress(progressCases)
    }, 500)
  }
  window.addEventListener('load', () => {
    setTimeout(scrollCases, 1000)
    $(window).on('resize', scrollCases)
  })
}

export default animateCases
